import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("article", { class: "message is-link ml-2 mr-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/_createElementVNode("p", null, "RESOLUCIÓN No. ANTAI-DS-008-2022")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "message-body" }, [
    /*#__PURE__*/_createTextVNode(" Por la cual se adopta e implementa el uso de la plataforma de monitoreo de transparencia para todas las instituciones públicas de la República de Panamá. "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.antai.gob.pa/wp-content/uploads/2022/10/Resolucion-008-22.pdf",
      target: "_blank"
    }, " Ver resolución aquí")
  ])
], -1)
const _hoisted_3 = {
  key: 2,
  id: "videos-block",
  class: "block card"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, " Videos ")
], -1)
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-header-title" }, " Redes sociales ")
], -1)
const _hoisted_8 = {
  ref: "socialMediaBlock",
  class: "card-content social-media-block"
}
const _hoisted_9 = ["data-adapt-container-width", "data-height", "data-width"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("blockquote", {
  cite: "https://www.facebook.com/antaipma",
  class: "fb-xfbml-parse-ignore"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "https://www.facebook.com/antaipma" }, "ANTAI Panamá")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { style: {"display":"grid","grid-template-columns":"1fr"} }
const _hoisted_13 = ["data-width"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Carousel = _resolveComponent("Carousel")!
  const _component_entity_index = _resolveComponent("entity-index")!
  const _component_MicroSite = _resolveComponent("MicroSite")!
  const _component_ShowVideos = _resolveComponent("ShowVideos")!
  const _component_GeneralStatistics = _resolveComponent("GeneralStatistics")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.carouselItemsAreAvailable)
      ? (_openBlock(), _createBlock(_component_Carousel, {
          key: 0,
          images: this.images,
          class: "negative-margin"
        }, null, 8, ["images"]))
      : _createCommentVNode("", true),
    _hoisted_2,
    _createVNode(_component_entity_index, { class: "block" }),
    (_ctx.microSitesAreAvailable)
      ? (_openBlock(), _createBlock(_component_MicroSite, {
          key: 1,
          "micro-sites": this.microSites,
          class: "block"
        }, null, 8, ["micro-sites"]))
      : _createCommentVNode("", true),
    (_ctx.videosAreAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_ShowVideos, {
              videos: this.videos
            }, null, 8, ["videos"]),
            _createElementVNode("button", {
              class: "button is-info is-medium is-fullwidth",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.moreVideos && _ctx.moreVideos(...args)))
            }, " Ver más videos ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_GeneralStatistics, { statistics: _ctx.statistics }, null, 8, ["statistics"])
    ]),
    (_openBlock(), _createElementBlock("div", {
      key: _ctx.triggerSocialMediaRemount,
      class: "card"
    }, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", null, [
          (this.showSocialMedia)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "data-adapt-container-width": this.facebookAdaptWidth,
                "data-height": this.remToPixel(30),
                "data-width": this.socialsChildWidth(),
                class: "fb-page",
                "data-hide-cover": "false",
                "data-href": "https://www.facebook.com/antaipma",
                "data-show-facepile": "true",
                "data-small-header": "false",
                "data-tabs": "timeline"
              }, _hoisted_11, 8, _hoisted_9))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_12, [
            (this.showSocialMedia)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  "data-width": this.socialsChildWidth(),
                  class: "twitter-timeline",
                  href: "https://twitter.com/ANTAI_Panama?ref_src=twsrc%5Etfw"
                }, " Tweets by ANTAI_Panama ", 8, _hoisted_13))
              : _createCommentVNode("", true)
          ])
        ])
      ], 512)
    ]))
  ]))
}